import React from "react";
import {
  Box,
  Grid,
  Typography,
  TextField,
  Button,
  Card,
  Divider,
} from "@mui/material";
import CallIcon from "@mui/icons-material/Call";
import ChatIcon from "@mui/icons-material/Chat";
import EmailIcon from "@mui/icons-material/Email";
import { useState } from "react";
import { toast } from "react-toastify";
import "../../App.css";
import { contact_enquiry } from "../../api/Enquiry";
import { useSettings } from "../../context/Settings";
import { CircularProgress } from "@mui/material";



export default function ContactUs() {

  const { settings, loadingg, error } = useSettings()

  const initialContactData = {
    name: "",
    email: "",
    message: "",
  };

  const [contactData, setContactData] = useState(initialContactData);

  const whatsapp = settings?.data?.whatsapp_number;
  const phone = settings?.data?.business_phone;
  const email = settings?.data?.business_email;




  const [loading, setLoading] = useState(false)

  const handleChange = (e) => {
    const { name, value } = e.target;


    // setContactData((prev) => ({ ...prev, [name]: value }));
    setContactData((prev) => {
      const updated = { ...prev, [name]: value };

      return updated;
    });




  };


  const [referralEmail, setReferralEmail] = useState("");
  // const navigate = useNavigate()
  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };


  const handleRedirect = (url) => {
    window.open(url, "_blank"); // open in new tab
  };


  const handleContactFormSubmit = async () => {




    if (!contactData.name?.trim()) {
      toast.error("Name is required");
      return;
    }

    if (!contactData.email) {
      toast.error("Email is required");
      return;
    }

    if (!validateEmail(contactData.email)) {
      toast.error("Enter a valid email address");
      return;
    }

    if (!contactData.message?.trim()) {
      toast.error("Message is required");
      return;
    }




    try {
      setLoading(true); // start loading
      const res = await contact_enquiry(contactData);

      toast.success(res?.message || "Contact Form Submitted Successfully");
      setContactData(initialContactData);

    } catch (err) {

      toast.error(err?.response?.data?.message || "Failed to submit form");
    } finally {
      setLoading(false); // stop loading
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        borderRadius: 4,
        backgroundImage: "url('/assets/images/contactbg1.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        p: { xs: 1, sm: 1.5 },
        overflow: "hidden",
        width: "100%",
        mx: "auto",
        gap: { xs: 1, sm: 2 },
        backgroundColor: "#FBFBF8",
      }}
    >
      <Box
        sx={{
          maxWidth: 800,
          width: "100%",
          mx: "auto",
          px: { xs: 2, sm: 3, md: 4 },
          textAlign: "center",
        }}
      >
        {/* TITLE */}
        <Typography fontWeight={400} mb={4} mt={3} fontSize={{ xs: 20, sm: 30 }}>
          Get In Touch With Us
        </Typography>

        <Grid container justifyContent={{ xs: "center", sm: "space-between" }} mb={4} gap={2}>
          <Grid item xs={12} sm={3} md={3}>
            <TopCard icon={<CallIcon />} title="Make a Call" href={`tel:${settings?.data?.phone ?? ""}`} />
          </Grid>

          <Grid item xs={12} sm={4}>
            <TopCard icon={<ChatIcon />} title="Make a Chat" href={`https://api.whatsapp.com/send?phone=${decodeURIComponent(
              settings?.data?.whatsapp
            ).replace(/\D/g, "")}`} />
          </Grid>

          <Grid item xs={12} sm={4}>
            <TopCard icon={<EmailIcon />} title="Write a Mail" href={`mailto:${settings?.data?.business_email}`} />
          </Grid>
        </Grid>

        {/* FORM CARD */}
        <div className="container-xl my-4 text-start">
          <div className="card shadow p-4 rounded-4 border-0">
            <div className="row g-4">

              {/* First Name */}
              <div className="col-12 col-md-6">
                <label className="form-label fw-semibold mb-1 text-start">
                  First Name  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  onChange={handleChange}
                  value={contactData.name}
                  name="name"
                  className="form-control custom-input"
                  placeholder="First Name"
                />

              </div>



              {/* Email */}
              <div className="col-12 col-md-6">
                <label className="form-label fw-semibold mb-1 text-start">
                  Email <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="email"
                  className="form-control custom-input"
                  value={contactData.email}
                  onChange={handleChange}
                  name="email"
                  placeholder="Email"
                />
              </div>


              {/* Message */}
              <div className="col-12">
                <label className="form-label fw-semibold mb-1 text-start">
                  Message <span style={{ color: "red" }}>*</span>
                </label>
                <textarea
                  className="form-control"
                  rows="4"
                  value={contactData.message}
                  onChange={handleChange}
                  name="message"
                  placeholder="Type message.."
                />
              </div>

              {/* Button */}
              <div className="col-12 mt-3">
                <button
                  className="btn px-5 py-2"
                  style={{
                    backgroundColor: "#7EAE23",
                    color: "#fff",
                    fontWeight: 600,
                    borderRadius: 8,
                  }}
                  onClick={handleContactFormSubmit}
                >
                  {loading ? (
                    <CircularProgress size={22} sx={{ color: "white" }} />
                  ) : (
                    "Submit"
                  )}

                </button>
              </div>

            </div>
          </div>
        </div>




        {/* BOTTOM ROW */}
        <Grid container justifyContent={{ xs: "center", sm: "space-between" }} mt={6} mb={6} gap={1.5} rowSpacing={4}>

          <Grid item xs={12} sm={12} md={3}>
            <BottomCard
              img="/assets/images/Grouplocation.png"
              title="Location"
              text={settings?.data?.business_address || ""}
            />
          </Grid>

          <VDivider />

          <Grid item xs={12} sm={12} md={3}>
            <BottomCard
              img="/assets/images/Groupcall.png"
              title="Contact"
              text={settings?.data?.business_phone || ""}
            />
          </Grid>

          <VDivider />

          <Grid item xs={12} sm={12} md={3}>
            <BottomCard
              img="/assets/images/Groupfollow.png"
              title="Follow Us"
            >
              <Box sx={{ display: "flex", justifyContent: "center", mt: 1, gap: 2 }}>
                <Box
                  component="img"
                  src="/assets/images/youtube.png"
                  height={30}
                  sx={{ cursor: "pointer" }}
                  // onError={(e) => { e.target.src = "/assets/images/placeholder.png"; }}
                  onClick={() =>
                    handleRedirect(settings?.data?.youtube || "https://www.youtube.com")
                  }
                />
                <Box
                  component="img"
                  src="/assets/images/whatsapp.png"
                  height={30}
                  sx={{ cursor: "pointer" }}
                  // onError={(e) => { e.target.src = "/assets/images/placeholder.png"; }}
                  onClick={() =>
                    handleRedirect(`https://wa.me/${settings?.data?.whatsapp}`)
                  }
                />
                <Box
                  component="img"
                  src="/assets/images/insta.png"
                  height={30}
                  sx={{ cursor: "pointer" }}
                  // onError={(e) => { e.target.src = "/assets/images/placeholder.png"; }}
                  onClick={() =>
                    handleRedirect(settings?.data?.instagram || "https://www.instagram.com")
                  }
                />
              </Box>
            </BottomCard>
          </Grid>

        </Grid>
      </Box>
    </Box>
  );
}



function TopCard({ icon, title, href }) {
  const isExternal = href?.startsWith("http");

  return (
    <Box
      component="a"
      href={href}
      target={isExternal ? "_blank" : undefined}
      rel={isExternal ? "noopener noreferrer" : undefined}
      sx={{
        textDecoration: "none",
        bgcolor: "#FEB821",
        borderRadius: 3,
        px: 3,
        py: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: 40,
        gap: 1,
        color: "#fff",
        cursor: "pointer",
        "&:hover": {
          bgcolor: "#e6a919",
        },
      }}
    >
      <Box sx={{ flexShrink: 0 }}>{icon}</Box>

      <Typography
        fontWeight={600}
        sx={{
          fontSize: { xs: 13, sm: 14, md: 15 },
          whiteSpace: "nowrap",
        }}
      >
        {title}
      </Typography>
    </Box>
  );
}


/* ===== BOTTOM CARD ===== */
function BottomCard({ img, title, text, children }) {
  return (
    <Box
      textAlign="center"
      sx={{
        minHeight: 170,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Box mb={1}>
        <img
          src={img}
          alt={title}
          width={50}
          height={50}
          // onError={(e) => { e.target.src = "/assets/images/placeholder.png"; }}
        />
      </Box>

      <Typography fontWeight={600}>{title}</Typography>

      {text && (
        <Typography
          fontSize={14}
          fontWeight={500}
          color="text.secondary"
          sx={{
            mt: 1,
            maxWidth: 230,
          }}
        >
          {text}
        </Typography>
      )}

      {children}
    </Box>
  );
}


/* ===== VERTICAL DIVIDER ===== */
const VDivider = () => (
  <Divider
    orientation="vertical"
    flexItem
    sx={{
      display: { xs: "none", sm: "block" },
      borderColor: "#e0e0e0",
      mx: 1,
    }}
  />
);